import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useCustomerInfoContext } from "../../context/CustomerInfoContext";

export const Balance = ({ type }: { type: string }) => {
  const {
    customerInfo,
    isCustomerLoading,
    getCustomerInfo,
    balanceData,
    pointData,
  } = useCustomerInfoContext();

  let title: string;
  let unit: string;
  let data: number;

  if (type === "jCredit") {
    title = "保有Jクレジット";
    unit = "g-CO2";
    data = customerInfo.jCredit ?? 0;
  } else if (type === "point") {
    title = "保有ポイント";
    unit = "pt";
    data = pointData;
  } else {
    // デフォルトはecoPay
    title = "保有EcoPay残高";
    unit = "円";
    data = balanceData;
  }

  return (
    <>
      <Typography>{title}</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "center",
          mt: 1,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          {isCustomerLoading ? <CircularProgress /> : data.toLocaleString()}
        </Typography>
        <Typography fontSize="14px" sx={{ ml: 1 }}>
          {unit}
        </Typography>
        {type !== "point" && type !== "jCredit" && (
          <IconButton
            color="primary"
            onClick={getCustomerInfo}
            sx={{ py: 0, mt: "auto" }}
          >
            <CachedIcon />
          </IconButton>
        )}
      </Box>
    </>
  );
};
